import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ClassNames, css, } from '@emotion/react';
import { Fragment, memo, useCallback, useMemo, useState, } from 'react';
import { TransitionGroup, CSSTransition, } from 'react-transition-group';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { TabbedContainerTab, } from './TabbedContainerTab';
const defaultProps = {
    collapseVertical: false,
    initialSelectedTab: 0,
    selectedTab: undefined,
    tabData: [],
};
const TabbedContainer = ({ collapseVertical = defaultProps.collapseVertical, initialSelectedTab = defaultProps.initialSelectedTab, selectedTab = defaultProps.selectedTab, tabData = defaultProps.tabData, }) => {
    const [activeTab, setActiveTab,] = useState(initialSelectedTab);
    const tabListStyles = useMemo(() => (css `
        border-bottom-color: ${theme.colors.gray300};
        border-bottom-style: solid;
        border-bottom-width: ${styleUtils.rem(1)};
        display: flex;
        padding-bottom: 0;
        padding-top: 0;
      `), []);
    const currentTab = useMemo(() => ((selectedTab === undefined
        || selectedTab === null)
        ? activeTab
        : selectedTab), [
        activeTab,
        selectedTab,
    ]);
    const onClickTabItem = useCallback((tab) => {
        setActiveTab(tab);
    }, []);
    return (_jsxs("div", Object.assign({ css: styleUtils.borderBox }, { children: [_jsx("div", Object.assign({ css: [
                    tabListStyles,
                ] }, { children: tabData.map((child, index) => {
                    const { label, onClick, } = child;
                    return (_jsx(TabbedContainerTab, { activeTab: currentTab, index: index, label: label, onClick: (tab) => {
                            onClickTabItem(tab);
                            if (onClick) {
                                onClick(tab);
                            }
                        } }, label));
                }) })), _jsx(TransitionGroup, Object.assign({ component: null, exit: false }, { children: tabData.map((child, index) => (_jsx(Fragment, { children: index === currentTab && (_jsx(ClassNames, { children: ({ css: styles, }) => (_jsx(CSSTransition, Object.assign({ classNames: {
                                enter: styles `
                                opacity: 0;
                                overflow: hidden;
                              `,
                                enterActive: styles `
                                && {
                                  opacity: 1;
                                  ${styleUtils.transition('all')};
                                }
                              `,
                            }, in: true, timeout: {
                                enter: parseInt(theme.durationDefault, 10),
                                exit: 0,
                            } }, { children: _jsx("div", Object.assign({ css: css `
                                ${!collapseVertical && `padding: ${theme.spacing.x3} 0;`}
                              ` }, { children: child.content })) }))) })) }, child.label))) }))] })));
};
const MemoizedTabbedContainer = memo(TabbedContainer);
export { MemoizedTabbedContainer as TabbedContainer };
// MC-1068 Temporary hack for Storybook.
export default TabbedContainer;
